import { useLayoutEffect, useRef, useState } from 'react';

/** How long gems taken off a Pokémon stay to shrink away (their delay and shrink, in Card/styled Gem). */
const LEAVING_MS = 900;

/**
 * The damage gems just taken off (healed, by Potion or Leech Seed): the ones past the new count, still where they
 * were, for a moment so they can shrink away rather than vanish. A gem's place depends only on the Pokémon and its
 * number (gemLayout), so the ones that stay are where they were. Only for the same Pokémon (`seed`).
 *
 * @param {object[]} gems the gems now
 * @param {number} seed the Pokémon's gem seed
 * @returns {object[]} the gems leaving
 */
export default function useLeavingGems(gems, seed) {
  const before = useRef({ gems, seed });
  const [leaving, setLeaving] = useState([]);

  useLayoutEffect(() => {
    const was = before.current;
    before.current = { gems, seed };
    if (was.seed !== seed || gems.length >= was.gems.length) {
      return undefined;
    }
    setLeaving(was.gems.slice(gems.length));
    const timer = setTimeout(() => setLeaving([]), LEAVING_MS);
    return () => clearTimeout(timer);
  }, [gems.length, seed]); // eslint-disable-line react-hooks/exhaustive-deps

  return leaving;
}
